import React, { useMemo } from "react";

import * as R from "ramda";

import { groupChecklistNotificationFields } from "src/utils/chatroom";

import Form from "../Form";
import Values from "../Values";
import FieldContent from "./FieldContent";
import { ChecklistContent as StyledContent } from "./styles";

type Props = {
  timestamp: string;
  data: any;
  isApproval?: boolean;
  isApprovalRequest?: boolean;
  isReply?: boolean;
};

const ChecklistContent = ({
  timestamp,
  data,
  isApproval = false,
  isApprovalRequest = false,
  isReply = false,
}: Props) => {
  const fieldIds = R.keys(data.fields);
  const groupedFields = useMemo(() => {
    return groupChecklistNotificationFields(fieldIds, data.fields);
  }, [data.fields]);

  if (groupedFields.length === 0 || isApprovalRequest) {
    return null;
  }

  // Approval field notifications may not always be single field notifications
  if (isApproval && fieldIds.length === 1) {
    const fieldId = parseInt(String(fieldIds[0]), 10);
    const field = data.fields[fieldId];
    return <Values field={field} timestamp={timestamp} fieldId={fieldId} />;
  }

  return (
    <StyledContent isReply={isReply}>
      {groupedFields.map((group) => {
        if (group.type === "form") {
          return (
            <Form
              key={group.ids.join("-")}
              forms={data.fields[group.ids[0] ?? 0].forms}
              timestamp={timestamp}
              invertColors={isReply}
            />
          );
        }
        return (
          <FieldContent
            key={group.ids.join("-")}
            fields={group.ids}
            timestamp={timestamp}
            data={data}
            invertColors={isReply}
          />
        );
      })}
    </StyledContent>
  );
};

export default ChecklistContent;
